import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { DropdownOption } from '../forms/dropdown/dropdown.component';
import {
  FormControl,
  FormGroup,
  FormGroupDirective,
  NgForm,
  Validators,
} from '@angular/forms';
import { ApiService } from 'src/app/service/api.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { PannelDatePosition } from '../forms/date-range-selector/date-range-selector.component';
import { ErrorStateMatcher } from '@angular/material/core';
import {
  recaptchaHeaders,
  RecaptchaService,
} from 'src/app/service/recaptcha.service';

export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(
    control: FormControl | null,
    form: FormGroupDirective | NgForm | null,
  ): boolean {
    const isSubmitted = form && form.submitted;
    return !!(
      control &&
      control.invalid &&
      (control.dirty || control.touched || isSubmitted)
    );
  }
}

@Component({
  selector: 'app-custom-request-quote',
  templateUrl: './custom-request-quote.component.html',
  styleUrls: ['./custom-request-quote.component.css'],
})
export class CustomRequestQuoteComponent implements OnInit {
  /** Les ids doivent rester uniques : plusieurs instances cohabitent sur la page */
  private static instanceCount = 0;
  readonly uid = `request-quote-${++CustomRequestQuoteComponent.instanceCount}`;

  @Input() fromPage: string = 'Home page';
  @Input() isDroplocked: boolean = false;
  @Input() customStyle: object = { right: '-10px', width: 'auto' };
  myForm: FormGroup;
  isLoading = false;

  modalOpen: boolean = false;
  successMessage: string = '';
  @Input() selectedDestination: DropdownOption | null = null;
  constructor(
    private apiService: ApiService,
    private http: HttpClient,
    private recaptcha: RecaptchaService,
  ) {}
  ngOnInit(): void {
    this.myForm = new FormGroup({
      numberOfAdults: new FormControl<number | null>(null, Validators.required),
      numberOfChildren: new FormControl<number | null>(
        null,
        Validators.required,
      ),
      destinationName: new FormControl<string | null>(
        null,
        Validators.required,
      ),
      email: new FormControl('', [Validators.required, Validators.email]),
      dates: new FormControl(null, Validators.required),
      subscribtionControl: new FormControl<boolean | null>(null),
      contactNumber: new FormControl<string | null>(null, Validators.required),
    });

    this.apiService.getDestination().subscribe({
      next: (data) => {
        this.destinations = data.map((destination) => ({
          value: destination.destinationId,
          label: destination.destination,
        }));
      },
      error: (err) => {
        console.log(err);
      },
    });
  }
  selectFormControl = new FormControl('', Validators.required);
  numberOfAdults: DropdownOption[] = Array.from({ length: 10 }, (_, i) => ({
    value: String(i + 1),
    label: String(i + 1),
  }));
  numberOfChildren: DropdownOption[] = [
    { value: '0', label: '0' },
    ...this.numberOfAdults,
  ];

  matcher = new MyErrorStateMatcher();
  destinations: DropdownOption[];

  async onSubmit() {
    // Show warning if any
    this.myForm.markAllAsTouched();

    if (this.myForm.valid) {
      this.isLoading = true;

      // Jeton demande a la soumission : il n'est valable que 2 minutes.
      const token = await this.recaptcha.execute('request_quote');
      const formData = this.myForm.value;
      if (this.fromPage) formData.fromPage = this.fromPage;

      delete formData.dates;
      formData.destinationName = this.getSelectedLabel(
        formData.destinationName,
      );
      formData.numberOfAdults = this.getSelectedLabel(formData.numberOfAdults);
      formData.numberOfChildren = this.getSelectedLabel(
        formData.numberOfChildren,
      );

      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
        }),
      };

      formData.departureDate = new Date(
        `${this.myForm.get('dates')?.value.startDate}`,
      );

      if (this.myForm.get('dates')?.value.endDate) {
        formData.arrivalDate = new Date(
          `${this.myForm.get('dates')?.value.endDate}`,
        );

        formData.numberOfNights =
          (formData.arrivalDate.getTime() - formData.departureDate.getTime()) /
          (24 * 3600 * 1000);
      }
      if (this.myForm.get('subscribtionControl')?.value) {
        this.http
          .post(
            `https://email.luxuryholidaysdirect.com/contact/add?version=2&publicaccountid=7ed18b4e-56d5-423c-878e-f8a4a07cbc53&email=${this.myForm.value.email}`,
            JSON.stringify({
              email: this.myForm.value.email,
              field_firstname: '',
              field_lastname: '',
              publiclistid: 'cd405fda-994e-40f5-9aa8-c946073594c9',
              submit: 'Subscribe Now',
              publicaccountid: '7ed18b4e-56d5-423c-878e-f8a4a07cbc53',
              returnUrl: '',
              activationReturnUrl: '',
              alreadyactiveurl: '',
              activationTemplate: '',
              source: 'WebForm',
              verifyemail: 'false',
              captcha: 'true',
              sendActivation: 'true',
              notifyEmail: '',
            }),
            httpOptions,
          )
          .subscribe((res) => {
            (err) => {
              console.log(err);
            };
          });
      }
      this.http
        .post(`${environment.API_BASE_URL}quote`, formData, {
          headers: recaptchaHeaders(token),
        })
        .subscribe({
          next: (data) => {
            this.myForm.reset();
            this.isLoading = false;
            this.successMessage =
              'We’ve received your quote request. We’ll contact you soon.';
            this.openModal();
          },
          error: (err) => {
            this.myForm.reset();
            this.isLoading = false;
            // 400 = jeton anti-bot absent ou refuse, 429 = trop de demandes :
            // l'API renvoie un message lisible, on le montre tel quel.
            this.successMessage =
              err?.error?.Message ??
              err?.error?.detail ??
              'We could not send your request. Please reload the page and try again.';
            this.openModal();
          },
        });

    }
  }
  // datecondition
  getCurrentDate(): string {
    const currentDate = new Date();
    return currentDate.toISOString().split('T')[0];
  }
  openModal() {
    this.modalOpen = true;
  }
  closeModal() {
    this.modalOpen = false;
  }
  removeNonNumber(): void {
    const contactNumber = this.myForm.controls['contactNumber'].value;
    this.myForm.controls['contactNumber'].setValue(
      contactNumber?.replace(/\D/g, ''),
    );
  }
  private getSelectedLabel(option: DropdownOption) {
    return option.label;
  }
}
